<template>
  <div class="accordion__item">
    <h3 class="accordion__title" v-on:click="toggle" :class="{'active': this.show, 'activated' : this.shown}" :aria-controls="'accordion-item-id-' + id">
      <slot name="header"></slot>
    </h3>
    <transition name="accordion"
                v-on:before-enter="leave" v-on:enter="enter"
                v-on:before-leave="enter" v-on:leave="leave">
      <div :id="'accordion-item-id-' + id" v-show="show" class="accordion__content" :aria-expanded="show ? 'true' : 'false'"><slot></slot></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AccordionItem',
  props: {
    id: {
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      shown: false,
    };
  },
  methods: {
    toggle: function () {
      this.shown = true;
      // Fold up all other Accordion-items
      if (!this.show) {
        this.$root.$emit('accordion-toggle');
        this.$emit('accordion-activated', this.id);
      }
      this.show = !this.show;
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function (el) {
      el.style.height = '0';
    },
  },
  mounted() {
    // Fold up all other Accordion-items when this event occurs.
    this.$root.$on('accordion-toggle', () => {
      if (this.show) {
        this.show = false;
      }
    });

    if (this.active) {
      this.show = true;
      this.shown = true;
      this.$emit('accordion-activated', this.id);
    }
  },
}
</script>
